import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { GlobalEventTrackingService } from './app/core/services/global-event-tracking-service';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { environment } from '@ao/environments/environment';

Chart.register(ChartDataLabels);

setEnvironmentSpecificResources();
bootstrapApplication(AppComponent, appConfig)
  .then(applicationRef => {
    const globalEventTrackingService = applicationRef.injector.get(
      GlobalEventTrackingService
    );
    globalEventTrackingService.initializeGlobalEventTracking();
  })
  .catch(err => console.log(err));
function setEnvironmentSpecificResources() {
  document.title = environment.appName;
  const faviconTag = document.getElementById('appFavicon') as HTMLLinkElement;
  if (faviconTag) {
    faviconTag.href = environment.favIcon;
  }
}
